import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory, useRouteMatch } from 'react-router-dom';
import SimpleHeader from '../../../components/layout/SimpleHeader';
import Loader from '../../../components/Loader';
import useAxios from '../../../hooks/useAxios';
import { IGetInquiry } from '../../../models/boardCommunication.model';
import Editor from '../../../components/board/inquiry/Editor';
import { getInquiry, updateInquiry } from '../../../api/boardCommunication.api';
import useNotification from '../../../hooks/useNotification';
import ErrorResponse from '../../../components/ErrorResponse';

interface IMatch {
  communicationCode: string;
}

const BoardInquiryEdit = () => {
  const { t } = useTranslation();
  const match = useRouteMatch<IMatch>();
  const communicationCode = Number(match.params.communicationCode);
  const history = useHistory();
  const { successNotification } = useNotification();
  const { data: res, isLoading, error, execute } = useAxios<IGetInquiry>();
  const {
    data: submitRes,
    isLoading: submitIsLoading,
    error: submitError,
    execute: submitExecute,
  } = useAxios();

  useEffect(() => {
    if (communicationCode) {
      execute(getInquiry(communicationCode));
    }
  }, [communicationCode]);

  useEffect(() => {
    if (submitRes && !submitIsLoading) {
      successNotification(t('common.message.save1'));
      history.push('/board/inquiry');
    }
  }, [submitRes, submitIsLoading]);

  const onSubmit = (data: FormData) => {
    if (!communicationCode) return;
    submitExecute(updateInquiry(communicationCode, data));
  };

  return (
    <div className="content scrollbar">
      {isLoading || submitIsLoading ? <Loader /> : null}
      <ErrorResponse error={error} />
      <ErrorResponse error={submitError} />
      <SimpleHeader
        parentMenu={t('common.menu.board')}
        currentMenu={t('board.inquiry.title3')}
        iconFile="icon-board-big.svg"
      />
      <Editor inquiry={res?.data} onSubmit={onSubmit} />
    </div>
  );
};

export default BoardInquiryEdit;
